<template>
  <div>
    <div class="mgv-20px">
      <qd-switch v-model="withAzimut">
        {{ $t('cartographie.actions.withAzimut') }}
      </qd-switch>
      <qd-switch v-model="regroupMateriel" class="mgl-10px">
        {{ $t('cartographie.actions.regroupMateriel') }}
      </qd-switch>
    </div>
    <carte
      style="width: 100%; height: 65vh"
      typeMap="no_POI_map"
      :markers="markers"
      @markClicked="handleClickMark"/>
    <b-modal v-if="targetMark && $scopedSlots[targetMark.type]" v-model="popupMarkContent">
      <div class="card pd-40px">
        <slot :name="targetMark.type" :mark="targetMark"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import carte from '@/components/general/carte/carte';
import { TYPE_MARKERS } from '@/configuration/cartographie/cartographie';
import { getAll as getAllFaces } from '@/api/gabed/face';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    selection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      markers: [],
      withAzimut: true,
      regroupMateriel: false,
      popupMarkContent: false,
      targetMark: null,
    };
  },
  components: {
    carte,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    handleClickMark(mark) {
      this.targetMark = mark;
      this.popupMarkContent = true;
    },
    decalageMarkers(markers) {
      markers.forEach((mark, i) => {
        const index = markers.findIndex(m => {
          return m.position.lat === mark.position.lat && m.position.lng === mark.position.lng;
        });
        if (index !== i) {
          mark.position.lng += (Math.random() * 0.00005);
          mark.position.lat += (Math.random() * 0.00005);
        }
      });
    },
    async regroupMarkersMateriel(markers) {
      let newMarkers = cloneDeep(markers);
      const produitIds = newMarkers.filter(m => m.type === 'produitFaces').map(m => m.produitId);
      const societeIds = [...new Set(newMarkers.filter(m => m.type === 'produitFaces').map(m => m.societeId))];
      if (produitIds.length === 0) return newMarkers;
      const promises = societeIds.map(s => {
        return getAllFaces({
          limit: NO_PAGINATION,
          query: {
            produitIds: produitIds,
            societeId: s,
          },
        });
      });
      const faces = (await Promise.all(promises)).map(r => r.data.result.items).flat(1);
      const materielRegroupement = faces.reduce((a, face) => {
        if (a[face.materielId]) {
          a[face.materielId].push(face);
        } else {
          a[face.materielId] = [face];
        }
        return a;
      }, {});
      Object.keys(materielRegroupement).forEach(materielId => {
        if (materielRegroupement[materielId].length <= 1) return;
        const targetProduiId = materielRegroupement[materielId].map(f => f.produitId);
        const markerMateriel = cloneDeep(newMarkers.find(m => {
          return m.produitId === materielRegroupement[materielId][0].produitId;
        }));
        newMarkers = newMarkers.filter(m => !targetProduiId.includes(m.produitId));
        markerMateriel.type = 'materiels';
        markerMateriel.clickable = !!this.$scopedSlots.materiels;
        delete markerMateriel.produitId;
        markerMateriel.faces = materielRegroupement[materielId];
        newMarkers.push(markerMateriel);
      });
      return newMarkers;
    },
    async getMarkers() {
      let markers = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const promises = [];
        Object.keys(this.selection).forEach(type => {
          const utils = TYPE_MARKERS.find(t => t.type === type);
          if (!utils) return;
          this.selection[type].forEach(elem => {
            if (utils.isValid(elem)) {
              promises.push(utils.convertToMarker(
                elem,
                { withAzimut: this.withAzimut, clickable: !!this.$scopedSlots[utils.slot] },
              ));
            }
          });
        });
        markers = (await Promise.all(promises)).flat(3);
        if (this.regroupMateriel) {
          markers = await this.regroupMarkersMateriel(markers);
        }
        this.decalageMarkers(markers);
      } catch (e) {
        messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
      return markers;
    },
  },
  watch: {
    async withAzimut() {
      this.markers = await this.getMarkers();
    },
    async regroupMateriel() {
      this.markers = await this.getMarkers();
    },
  },
  async mounted() {
    this.markers = await this.getMarkers();
  },
};
</script>

<style>

</style>
